module.exports = __webpack_public_path__ + "img/Bolivia.29001c92.svg";